var style = {"z-info-tag":"z-info-tag","z-info-tag--primary":"z-info-tag--primary","z-info-tag--primary-solid":"z-info-tag--primary-solid","z-info-tag--secondary":"z-info-tag--secondary","z-info-tag--neutral":"z-info-tag--neutral","z-info-tag--info":"z-info-tag--info","z-info-tag--success":"z-info-tag--success","z-info-tag--warning":"z-info-tag--warning","z-info-tag--danger":"z-info-tag--danger"};

export { style as default };
//# sourceMappingURL=InfoTag.module.scss.js.map
